<template>
  <div class="group-box">
    <div class="box-title">
      <div class="title">系统默认</div>
      <div class="tips">不可修改</div>
    </div>
    <div class="box-list">
      <div v-for="(item, index) in tag" :key="index" class="box-one">
        <div :style="{ backgroundColor: item.bgcolor }" class="bgc"></div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>

  <div class="group-box">
    <div class="box-title">
      <div class="title">自定义</div>
      <div>
        <a-button type="link" @click="openAdd">添加</a-button>
      </div>
    </div>
    <div class="box-list">
      <div
          v-for="(item, index) in customtag"
          :key="index"
          class="box-one"
          style="cursor: pointer"
          @click="openEdit(item)"
      >
        <div
            :style="{ backgroundColor: item.bgcolor }"
            class="bgc"
            title="点击编辑"
        ></div>
        <div class="name" title="点击编辑">{{ item.name }}</div>
        <div class="del" title="删除" @click.stop="handleDel(item)">
          <close-outlined/>
        </div>
      </div>
    </div>
  </div>

  <a-modal v-model:visible="visibleAdd" :title="modalTitle" @ok="modalOk">
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="form"
        :rules="rules"
        :wrapper-col="{ offset: 1 }"
    >
      <a-form-item label="名称：" name="name">
        <a-input
            v-model:value="form.name"
            placeholder="请输入名称"
            style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="颜色：" name="bgcolor">
        <a-input
            v-model:value="form.bgcolor"
            style="width: 30px; height: 34px; padding: 0 1px"
            type="color"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {CloseOutlined, ExclamationCircleOutlined,} from "@ant-design/icons-vue";
import {createVNode, onMounted, reactive, toRefs} from "vue";
import {tagAdd, tagDel, tagEdit, tagList} from "@/api/api";
import {message, Modal} from "ant-design-vue";

export default {
  components: {
    CloseOutlined,
  },
  setup() {
    const list = reactive({
      tag: [],
      customtag: [],
      // 获取来源列表
      getTagList() {
        tagList().then((res) => {
          list.tag = res.data.filter((i) => i.type !== 3);
          list.customtag = res.data.filter((i) => i.type == 3);
        });
      },
      openAdd() {
        modal.form = {
          name: "",
          bgcolor: "#0094ff",
        };
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.visibleAdd = true;
        modal.modalTitle = "添加标签";
      },
      openEdit(item) {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.form.id = item.id;
        modal.form.name = item.name;
        modal.form.bgcolor = item.bgcolor;
        modal.visibleAdd = true;
        modal.modalTitle = "编辑标签";
      },
      // 删除账号
      handleDel(item) {
        Modal.confirm({
          title: "提示",
          content: "是否删除？",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            tagDel({tag_id: item.id}).then((res) => {
              message.success(res.msg);
              list.getTagList();
            });
          },
        });
      },
    });

    const modal = reactive({
      type: "",
      visibleAdd: false,
      modalTitle: "",
      form: {
        name: "",
        bgcolor: "",
      },
      formRef: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
      modalOk() {
        modal.formRef.validate().then(() => {
          if (modal.form.id) {
            tagEdit({
              name: modal.form.name,
              bgcolor: modal.form.bgcolor,
              tag_id: modal.form.id,
            }).then((res) => {
              message.success(res.msg);
              modal.visibleAdd = false;
              list.getTagList();
            });
          } else {
            tagAdd(modal.form).then((res) => {
              message.success(res.msg);
              modal.visibleAdd = false;
              list.getTagList();
            });
          }
        });
      },
    });

    onMounted(() => {
      list.getTagList();
    });

    return {
      ...toRefs(modal),
      ...toRefs(list),
    };
  },
};
</script>

<style lang="scss" scoped>
.group-box {
  background-color: #fff;
  width: 100%;
  box-shadow: 0 0 5px #99999933;
  margin: 10px;

  .box-title {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
      font-size: 16px;
      color: #000000;
      margin-right: 10px;
    }

    .tips {
      color: #999999;
      font-size: 12px;
      margin-top: 2px;
    }
  }

  .box-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px;

    .box-one {
      padding: 6px 10px;
      border: 1px solid #cccccc;
      border-radius: 20px;
      min-width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 10px 10px 0;

      .bgc {
        height: 20px;
        width: 20px;
      }

      .name {
        margin-left: 5px;
      }

      .del {
        margin-left: 6px;

        &:hover {
          color: #da0000;
        }
      }
    }
  }
}
</style>
